import _asyncToGenerator from "/vercel/workpath0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/workpath0/node_modules/@babel/runtime/regenerator";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { util } from '@tensorflow/tfjs-core';
import { FileChunkIterator } from './file_chunk_iterator';
/**
 * Provide a stream of chunks from a URL.
 *
 * Note this class first downloads the entire file into memory before providing
 * the first element from the stream.  This is because the Fetch API does not
 * yet reliably provide a reader stream for the response body.
 */

export function urlChunkIterator(_x) {
  return _urlChunkIterator.apply(this, arguments);
} // Generate RequestInit from Request to match tf.util.fetch signature.

function _urlChunkIterator() {
  _urlChunkIterator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var options,
        urlString,
        requestInit,
        response,
        uint8Array,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

            if (typeof url === 'string') {
              urlString = url;
            } else {
              urlString = url.url;
              requestInit = getRequestInitFromRequest(url);
            }

            _context.next = 4;
            return util.fetch(urlString, requestInit);

          case 4:
            response = _context.sent;

            if (!response.ok) {
              _context.next = 14;
              break;
            }

            _context.t0 = Uint8Array;
            _context.next = 9;
            return response.arrayBuffer();

          case 9:
            _context.t1 = _context.sent;
            uint8Array = new _context.t0(_context.t1);
            return _context.abrupt("return", new FileChunkIterator(uint8Array, options));

          case 14:
            throw new Error(response.statusText);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _urlChunkIterator.apply(this, arguments);
}

var getRequestInitFromRequest = function getRequestInitFromRequest(request) {
  var init = {
    method: request.method,
    headers: request.headers,
    body: request.body,
    mode: request.mode,
    credentials: request.credentials,
    cache: request.cache,
    redirect: request.redirect,
    referrer: request.referrer,
    integrity: request.integrity
  };
  return init;
};